'use strict';

angular.module('shiftTraderApp')
    .controller('DaysOffContentPendingListCtrl', function($scope, AvailabilityRules, TimeService, $state, $stateParams, $location,
                                           SAErrorHandler, $timeout, me, daysOff, org, $rootScope,
                                           Session, allMinUsers, $interval, DaysOffUserStatsService, WorkPeriods,
                                           DaysOffRouteSyncService, $uibModal, DaysOffManagementModalService,
                                           ViewDayOffModalService) {
      $scope.me = me;
      $scope.org = org;

      var baseDaysOff = daysOff;

      $scope.allDepartments = _.map($scope.org.departments, function(dept) {
        dept._selected = true;
        return dept;
      });

      $scope.allMinUsers = _.sortBy(_.map(_.where(allMinUsers, function(u) {
        return u.$curMemb().active === 1;
      }), function(u) {
        u._filteredDayOffCount = 0;
        return u;
      }), 'first_name');

      $scope.nowDate = TimeService.getNowInStoreTime();
      $scope.currentDate = TimeService.getBeginningOfDayFromDate(moment.utc($stateParams.date)).startOf('month');
      $scope.workDayStartHour = Session.getWorkDayStartHour();

      $scope.state = {
        selectedDepartments: _.cloneDeep($scope.org.departments)
      };

      $rootScope.$on('daysOff:filterChange', function() {
        var filters = DaysOffRouteSyncService.getFilters();

        $scope.state.selectedDepartments = _.where($scope.allDepartments, function(dept) {
          return _.contains(filters.departmentIds, dept.id);
        });

        calculateDaysOffDataStructure();
      });

      $scope.datesByWeek = _.map($scope.weeks, function(week) {
        return _.map(_.range(7), function(dayNum) {
          return moment(week.start).add(dayNum, 'days').twix(moment(week.start).add(dayNum + 1, 'days'));
        });
      });

      var calculateDaysOffDataStructure = function () {
        var departmentIdsToShow = _.pluck($scope.state.selectedDepartments, 'id');

        $scope.filteredDaysOff = _.sortBy(_.where($scope.allDaysOff, function(dor) {
          var hasDeptMetadata = dor.user.metadata && dor.user.metadata.department_ids_by_org &&
              dor.user.metadata.department_ids_by_org.data && dor.user.metadata.department_ids_by_org.data[dor.organization_id]
            && dor.user.metadata.department_ids_by_org.data[dor.organization_id].length > 0;

          return dor.$isPending() && !dor.$isExpired() && !dor.$wasCancelledOrRemoved() && (!hasDeptMetadata || _.any(departmentIdsToShow, function(idToShow) {
            return _.contains(dor.user.metadata.department_ids_by_org.data[dor.organization_id], idToShow);
          }));
        }), function(dor) {
          return dor.start.unix();
        });
      };


      //$scope.manageRequest = function(request) {
      //  ViewDayOffModalService.openViewDayOffModal(request.id, function(status, result) {
      //    var idx = _.findIndex(baseDaysOff, function(dor) {
      //      return dor.id === result.id;
      //    });
      //
      //    if (idx > -1) {
      //      baseDaysOff[idx] = result;
      //      processBaseDaysOff();
      //    }
      //  });
      //};

      $scope.openDayOffManagementModal = function(dayOffRequest) {
        DaysOffManagementModalService.setCurrentDate(moment(dayOffRequest.start));
        //DaysOffManagementModalService.setSelectedDayOffId(dayOffRequest.id);

        var modalInstance = $uibModal.open({
          size: 'days-off-management',
          templateUrl: 'views/daysOff/daysOffManagementModal.html',
          controller: 'DaysOffManagementModalCtrl',
          resolve: {
            params: function() {
              return {
                me: $scope.me,
                allDaysOff: $scope.allDaysOff,
                org: $scope.org,
                allUsers: $scope.allMinUsers,
                selectedDayOffId: dayOffRequest.id
              };
            }
          },
          rxName: 'days-off-management'
        });
        modalInstance.result.then(function(result) {
            console.log('closed days off management modal');
            console.log(result);
            reloadDaysOffData();
          },
          function(reason) {
            console.log('dismissed explanation with reason ' + reason);

          });
      };

    function processBaseDaysOff() {
      $scope.allDaysOff = _.map(baseDaysOff, function(dayOff) {
        dayOff.created_at_tz = moment.utc(dayOff.created_at).tz(Session.getTimezone());
        dayOff.timeAgo = dayOff.created_at_tz.twix($scope.nowDate);
        dayOff._mif = TimeService.minimalIntervalTimeFormat(dayOff.range_twix);

        return dayOff;
      });

      calculateDaysOffDataStructure();
    }

    function reloadDaysOffData() {
      AvailabilityRules.getAllDaysOffNeedingApproval()
         .then(function(results) {
           baseDaysOff = results;
           processBaseDaysOff();
         }, function(response) {

         });
    }

    processBaseDaysOff();

    });
